<template>
  <div>
    <v-menu
      bottom
      :close-on-content-click="false"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <i
          class="v-icon notranslate v-theme--light v-icon--size-default text-medium-emphasis mx-1"
          aria-hidden="true"
          v-on="on"
          v-bind="attrs"
        >
          <img
            class="mdn-bellWhite"
            src="@/assets/bell-white.svg"
            width="26"
          >

          <span
            class="v-badge__badge v-theme--light"
            aria-atomic="true"
            aria-label="Badge"
            aria-live="polite"
            role="status"
            style="color: rgb(0, 0, 0); background-color: rgb(255, 220, 0); bottom: calc(65% - 8px); left: calc(90% - 8px);"
          >
            {{ listaDeAlertasNaoLidos.length }}
          </span>
        </i>
      </template>

      <v-list dense width="400" style="margin: 0;">
        <v-list-item>
          <v-list-item-title>
            <div class="text-h6">
              Alertas
            </div>
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-for="(alerta, index) in listaDeAlertasNaoLidos"
          :key="index"
          class="mb-3 mt-3"
          :menu="alerta"
        >
          <v-list-item-icon>
            <img
              class="mdn-alertYellow"
              src="@/assets/alert-yellow.svg"
            >
          </v-list-item-icon>

          <v-list-item-title>
            <div
              class="text-h7"
              style="color: rgb(255, 0, 0);"
            >
              {{ alerta.ctrl_tipo_notificacao?.descricao || 'Notificação' }}
            </div>

            <div class="text-caption mb-1">
              {{ dataHoraAbertura(alerta.created_at) }} 
            </div>

            <div class="text-medium-emphasis text-caption notificacao-previa">
              {{ alerta.mensagem }}
            </div>
          </v-list-item-title>

          <v-list-item-icon
            class="cursor-pointer"
            @click="exibirMensagem(alerta)"
          >
            <v-icon
              color="red"
              width="30"
              v-b-tooltip.top
              title="Ver mensagem"
              right
            >
              mdi-eye
            </v-icon>
          </v-list-item-icon>

          <v-list-item-icon class="cursor-pointer">
            <v-checkbox
              :on-icon="'mdi-email-check'"
              :off-icon="'mdi-email-mark-as-unread'"
              v-model="selected"
              :value="alerta.id"
              style="margin-top: -5px;"
              v-b-tooltip.righttop
              title="Marcar como lido"
              @click="confirmarLeitura(alerta.id)"
            />
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>

    <SGPModalComponent
      :titulo="mensagemTitulo"
      v-if="mostrarModal"
      tamanho="lg"
      @sgpModalFechar="mostrarModal = false"
    >
      <div>
        <SGPColComponent cols="12">
          <p class="text-caption mb-2">
            {{ dataHoraCompleta(mensagemData) }}
          </p>

          <span class="text-h6 mensagem-com-quebras">
            {{ mensagem }}
          </span>

          <p
            class="mt-3"
            style="font-size: 14px;"
            v-if="linkProcesso"
          >
            <strong>
              <a
                :href="getLinkProcesso(linkProcesso)"
                target="_blank"
              >
                Link Processo
              </a>
            </strong>
          </p>

        </SGPColComponent>

        <SGPColComponent
          cols="12"
          class="ml-1"
          style="text-align: right;"
        >
          <SGPFormBotaoComponent
            @click="confirmarLeitura(mensagemId)"
            text
            color="primary"
            class="mt-3"
          >
            <SGPIconComponent
              color="primary"
              icon="mdi-email-mark-as-unread"
              middle
              class="mr-3 ml-3"
            />

            Marcar como lido
          </SGPFormBotaoComponent>
        </SGPColComponent>
      </div>
    </SGPModalComponent>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NotificacaoHeaderComponent',

  data() {
    return {
      mostrarModal: false,
      mensagemTitulo: '',
      mensagem: '',
      mensagemData: null,
      mensagemId: '',
      linkProcesso: '',
      selected: [],
      pollingTimer: null,
    };
  },

  computed: {
    ...mapGetters('pcoNotificacoes', [
      'listaDeNotificacoesNaoLidas',
      'carregandoNotificacoes'
    ]),

    listaDeAlertasNaoLidos() {
      return this.listaDeNotificacoesNaoLidas;
    },
  },

  methods: {
    ...mapActions('pcoNotificacoes', {
      listarNotificacoesNaoLidas: 'listarNotificacoesNaoLidas',
      confirmarLeituraNotificacao: 'confirmarLeitura'
    }),

    exibirLidos() {
      this.$router.push('/sgp/pco-mensagens/mensagens-lidas/alertas');
    },

    atualizarNotificacoes() {
      if (!this.carregandoNotificacoes) {
        return this.listarNotificacoesNaoLidas();
      }
    },

    confirmarLeitura(idMensagem) {
      if (idMensagem) {
        return this.confirmarLeituraNotificacao(idMensagem).then(() => {
          this.mostrarModal = false;
        });
      }
    },

    getLinkProcesso(link) {
      if (!link) {
        return '#';
      }

      if (/^https?:\/\//i.test(link)) {
        return link;
      }

      return this.$router.resolve({ path: `/${link.replace(/^\/+/, '')}` }).href;
    },

    exibirMensagem(msg) {
      this.mensagemTitulo = msg.ctrl_tipo_notificacao?.descricao || 'Notificação';
      this.mensagem = msg.mensagem;
      this.mensagemData = msg.created_at;
      this.mensagemId = msg.id;
      this.linkProcesso = msg.link || '';
      this.mostrarModal = true;
    },

    dataHoraAbertura(dtFim) {
      const dtIni = moment().format('YYYYMMDDHHmm');
      const nDtFim = moment(dtFim).format('YYYYMMDDHHmm');
      const dtDiff = dtIni - nDtFim;

      if (dtDiff < 60) {
        return `${dtDiff} minuto(s)`;
      }

      return moment(dtFim).format('DD/MM/YYYY HH:mm');
    },

    dataHoraCompleta(data) {
      return data ? moment(data).format('DD/MM/YYYY HH:mm') : '';
    }
  },

  mounted() {
    this.atualizarNotificacoes();
    this.pollingTimer = setInterval(() => {
      this.atualizarNotificacoes();
    }, 60 * 1000);
  },

  beforeDestroy() {
    clearInterval(this.pollingTimer);
  },

  watch: {
    listaDeAlertasNaoLidos() {
      this.selected = [];
    }
  }
};
</script>

<style scoped>
.v-list {
  height: auto;
  max-height: 480px;
  overflow-y: auto;
}

.mensagem-com-quebras {
  white-space: pre-line;
}

.notificacao-previa {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
